<div class="relative">
  <div class="container w-[270px] min-w-full">
    <div
      class="w-full flex flex-col sm:flex-row sm:justify-between border-b border-[#bb0021] py-2"
    >
      <div class="flex items-cente gap-3 w-full">
        <button
          style="cursor: pointer"
          *ngIf="user.userType === !SETTINGS.USERS.MEMBER"
          class="bg-[#19191A] rounded p-2"
          (click)="navigateToView()"
        >
          <tui-svg
            src="tuiIconArrowLeftCircleLarge"
            style="color: #bb0021"
          ></tui-svg>
        </button>
        <div>
          <h2 class="flex items-center text-[#6A6A6A]">
            {{ memberData?.firstname }} {{ memberData?.lastname }}
          </h2>
          <h3 class="flex items-center text-[#6A6A6A]">
            Member ID : {{ memberData?.membershipId }}
          </h3>
        </div>
        <div
          class="flex flex-row items-center gap-1 bg-[#D8D8D8] rounded-full px-1 h-1/2"
          *ngIf="memberData?.isActive"
        >
          <div class="w-[10px] h-[10px] rounded-full bg-[#4AC99B]"></div>
          <div class="">
            <h3 class="text-[#6A6A6A]">Active</h3>
          </div>
        </div>
        <div
          class="flex flex-row items-center gap-1 bg-[#1F2021] rounded-full px-1 h-1/2"
          *ngIf="!memberData?.isActive"
        >
          <div class="w-[10px] h-[10px] rounded-full bg-[#FC4761]"></div>
          <div class="">
            <h3 class="text-[#6A6A6A]">Inactive</h3>
          </div>
        </div>
      </div>
      <div *ngIf="user.userType === SETTINGS.USERS.MEMBER" class="mt-5 sm:mt-0">
        <button tuiButton (click)="paymentPageNavigate()">
          <div
            class="flex justify-center items-center w-[180px] sm:w-[160px] btn-outline"
          >
            <p class="flex justify-center items-center text-[13px] h-[24px]">
              Add Payment
            </p>
          </div>
        </button>
      </div>
    </div>
    <div class="flex sm:items-center sm:gap-4 flex-col sm:flex-row mt-3">
      <tui-tabs class="overflow-x-auto" [(activeItemIndex)]="tabIndex">
        <a tuiTab (click)="tabChange(0)" class="text-xs mr-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-layout-list mr-2"
          >
            <rect width="7" height="7" x="3" y="3" rx="1" />
            <rect width="7" height="7" x="3" y="14" rx="1" />
            <path d="M14 4h7" />
            <path d="M14 9h7" />
            <path d="M14 15h7" />
            <path d="M14 20h7" />
          </svg>
          Member Details
        </a>
        <a
          tuiTab
          (click)="tabChange(1)"
          class="text-xs mr-3"
          style="cursor: pointer; --tui-tab-margin: 10px"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-list-checks mr-2"
          >
            <path d="m3 17 2 2 4-4" />
            <path d="m3 7 2 2 4-4" />
            <path d="M13 6h8" />
            <path d="M13 12h8" />
            <path d="M13 18h8" />
          </svg>
          Payment Information
        </a>
        <a
          tuiTab
          (click)="tabChange(2)"
          class="text-xs"
          style="cursor: pointer; --tui-tab-margin: 10px"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-heart-pulse mr-2"
          >
            <path
              d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
            />
            <path d="M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27" />
          </svg>
          Health Analysis
        </a>
        <a
          *ngIf="user.userType === SETTINGS.USERS.MEMBER"
          tuiTab
          (click)="tabChange(3)"
          class="text-xs"
          style="cursor: pointer; --tui-tab-margin: 10px"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-key-round mr-2"
          >
            <path
              d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z"
            />
            <circle cx="16.5" cy="7.5" r=".5" fill="currentColor" />
          </svg>
          Change Password
        </a>
      </tui-tabs>
    </div>
  </div>
  <button
    tuiButton
    appearance="secondary"
    class="text-[#bb0021] hover:bg-[#faf0f2] hover:text-[#bb0021] my-4"
    (click)="goBack()"
  >
    <div class="flex flex-row items-center p-4">
      <tui-svg src="tuiIconArrowLeftCircleLarge" class="mr-2"></tui-svg>
      Back
    </div>
  </button>
  <section id="member-details" *ngIf="tabIndex === 0">
    <div class="flex justify-center mt-5 sm:mt-20">
      <div class="flex flex-col w-full sm:w-3/4 md:2/4 lg:w-2/4">
        <div class="relative pb-2">
          <div
            class="w-32 h-32 rounded-full border-2 border-gray-300 overflow-hidden bg-gray-100 flex items-center justify-center"
          >
            <img
              *ngIf="memberData?.profilePicture?.length > 0"
              [src]="memberData.profilePicture[0].url"
              [alt]=""
              class="w-full h-full object-cover rounded-full"
            />
            <tui-svg
              *ngIf="!memberData?.profilePicture?.length"
              src="tuiIconUser"
              class="w-8 h-8 text-gray-400"
            ></tui-svg>
          </div>
        </div>
        <div class="flex justify-between border-b border-b-[#6A6A6A] pb-2">
          <div>
            <p class="text-[#19191A]">Member Name</p>
            <p class="text-black">
              {{ memberData?.firstname }} {{ memberData?.lastname }}
            </p>
          </div>
          <div
            class="flex items-center bg-[#D8D8D8] rounded p-2 overflow-hidden"
            (click)="onClick()"
            style="cursor: pointer"
          >
            <button
              [tuiDropdown]="dropdownContent"
              [tuiDropdownManual]="openStates"
              (tuiActiveZoneChange)="onActiveZone()"
              (tuiObscured)="onObscured($event)"
            >
              <!-- <img src="/src/assets/img/edit-icon.png" alt=""> -->
              <tui-svg
                src="tuiIconMoreVerticalLarge"
                class="hover:scale-110 transition-all duration-200"
                style="color: #6a6a6a"
              ></tui-svg>
              <ng-template #dropdownContent>
                <div
                  class="dropdown dropdownContent"
                  (click)="navigateToUpdate()"
                >
                  Edit
                </div>
                <div *ngIf="user.userType === SETTINGS.USERS.ADMIN">
                  <div
                    class="dropdown dropdownContent"
                    *ngIf="!memberData.isActive"
                    (click)="onStatusChange(memberData)"
                  >
                    Set as Active
                  </div>
                  <div
                    class="dropdown dropdownContent"
                    *ngIf="memberData.isActive"
                    (click)="onStatusChange(memberData)"
                  >
                    Set as Inactive
                  </div>
                  <div
                    class="dropdown dropdownContent"
                    style="color: red"
                    (click)="onDelete()"
                  >
                    Delete
                  </div>
                </div>
              </ng-template>
            </button>
          </div>
        </div>
        <div class="flex flex-col sm:flex-row mt-2 w-full">
          <div class="border-b border-b-[#6A6A6A] w-full sm:w-1/2 pb-2">
            <p class="text-[#19191A]">Date of Birth</p>
            <p class="text-black">{{ formatDate(memberData?.dob) }}</p>
          </div>
          <div class="border-b border-b-[#6A6A6A] w-full sm:w-1/2 pb-2">
            <p class="text-[#19191A]">Gender</p>
            <p class="text-black" *ngIf="memberData?.gender === 'MALE'">Male</p>
            <p class="text-black" *ngIf="memberData?.gender === 'FEMALE'">
              Female
            </p>
            <p class="text-black" *ngIf="memberData?.gender === 'OTHER'">
              Other
            </p>
          </div>
        </div>
        <div class="flex flex-col sm:flex-row mt-2 w-full">
          <div class="border-b border-b-[#6A6A6A] w-full sm:w-1/2 pb-2">
            <p class="text-[#19191A]">Email address</p>
            <p class="text-black">{{ memberData?.email }}</p>
          </div>
          <div class="border-b border-b-[#6A6A6A] w-full sm:w-1/2 pb-2">
            <p class="text-[#19191A]">Mobile Number</p>
            <p class="text-black">{{ memberData?.mobileNo }}</p>
          </div>
        </div>
        <div class="flex border-b border-b-[#6A6A6A] py-2">
          <div>
            <p class="text-[#19191A]">Address</p>
            <p class="text-black">{{ memberData?.address }}</p>
          </div>
        </div>
        <div
          class="flex border-b border-b-[#6A6A6A] py-2"
          *ngIf="memberData?.programs.length > 0"
        >
          <div>
            <p class="text-[#19191A]">Programs</p>
            <div class="flex gap-1">
              <span class="text-black">
                <p>{{ displayArrayWithCommas(memberData?.programs) }}</p>
              </span>
            </div>
          </div>
        </div>
        <div class="flex flex-col sm:flex-row mt-2 w-full py-4">
          <div class="w-full">
            <div class="flex justify-between items-center gap-2">
              <label class="text-black ml-1">Goals</label>
              <svg
                *ngIf="user.userType === SETTINGS.USERS.ADMIN"
                (click)="onClickCancelGoals(goalContent)"
                style="cursor: pointer"
                class="mr-1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="15"
                height="15"
                viewBox="0,0,256,256"
              >
                <g transform="">
                  <g
                    fill-opacity="0"
                    fill="#dddddd"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                  >
                    <path d="M0,256v-256h256v256z" id="bgRectangle"></path>
                  </g>
                  <g
                    fill="#bb0021"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                  >
                    <g transform="scale(5.12,5.12)">
                      <path
                        d="M43.125,2c-1.24609,0 -2.48828,0.48828 -3.4375,1.4375l-0.8125,0.8125l6.875,6.875c-0.00391,0.00391 0.8125,-0.8125 0.8125,-0.8125c1.90234,-1.90234 1.89844,-4.97656 0,-6.875c-0.95312,-0.94922 -2.19141,-1.4375 -3.4375,-1.4375zM37.34375,6.03125c-0.22656,0.03125 -0.4375,0.14453 -0.59375,0.3125l-32.4375,32.46875c-0.12891,0.11719 -0.22656,0.26953 -0.28125,0.4375l-2,7.5c-0.08984,0.34375 0.01172,0.70703 0.26172,0.95703c0.25,0.25 0.61328,0.35156 0.95703,0.26172l7.5,-2c0.16797,-0.05469 0.32031,-0.15234 0.4375,-0.28125l32.46875,-32.4375c0.39844,-0.38672 0.40234,-1.02344 0.01563,-1.42187c-0.38672,-0.39844 -1.02344,-0.40234 -1.42187,-0.01562l-32.28125,32.28125l-4.0625,-4.0625l32.28125,-32.28125c0.30078,-0.28906 0.39063,-0.73828 0.22266,-1.12109c-0.16797,-0.38281 -0.55469,-0.62109 -0.97266,-0.59766c-0.03125,0 -0.0625,0 -0.09375,0z"
                      ></path>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <tui-textarea
              [(ngModel)]="goals"
              class="tui-space_bottom-4 field-small mt-2 note-section"
              disabled="true"
            >
            </tui-textarea>
          </div>
        </div>
        <ng-template #goalContent let-context>
          <tui-textarea
            [(ngModel)]="tempGoals"
            class="tui-space_bottom-4 field-medium mt-2"
          >
          </tui-textarea>
          <div class="flex gap-3" style="justify-content: center">
            <button
              tuiButton
              (click)="context.complete()"
              class="modal-button"
              appearance="flat"
            >
              Cancel
            </button>
            <button
              tuiButton
              (click)="saveGoals(); context.complete()"
              class="modal-button"
            >
              Save
            </button>
          </div>
        </ng-template>
        <div class="bg-[#faf0f2] rounded p-5 mt-2">
          <h5 class="text-[#19191A]">Emergency Contact Details</h5>
          <div class="flex flex-col sm:flex-row mt-2">
            <div class="w-full sm:w-1/2">
              <p class="text-[#19191A]">Name</p>
              <p class="text-black">{{ memberData?.emergencyContact?.name }}</p>
            </div>
            <div class="w-full sm:w-1/2">
              <p class="text-[#19191A]">Contact Number</p>
              <p class="text-black">
                {{ memberData?.emergencyContact?.mobileNo }}
              </p>
            </div>
          </div>
        </div>

        <p class="text-[#19191A] mt-4 mb-4 bg-[#faf0f2] rounded p-5">
          Member Since {{ formatDateText(memberData?.registrationDate) }}
        </p>

        <!-- <div class="bg-[#19191A] rounded p-5 mt-2 border border-[#bb0021] flex flex-col gap-2">
          <p class="text-[0.75rem] text-[#bb0021]">Package Details</p>
          <h4 class="text-[1.25rem]">{{ memberData?.package?.name }} - {{ memberData?.package?.month > 1 ? memberData?.package?.month + " Months" : memberData?.package?.month + " Month" }} - {{"LKR " + (memberData?.package?.price | number:'1.2-2') }}</h4>
          <p class="text-[0.75rem] text-[#A5A5A5]">Includes</p>
          <ul class="pl-5 list-disc">
            <li *ngFor="let item of memberData?.package?.description">{{ item }}</li>
          </ul>
          <button *ngIf="user.userType === SETTINGS.USERS.MEMBER" tuiButton appearance="outline" class="w-[180px] sm:w-[160px]" (click)="paymentPageNavigate()">
            <div class="flex justify-center items-center">
             <p class="flex justify-center items-center text-[13px] h-[24px]">Add Payment</p>
            </div>
          </button>
          <div *ngIf="user.userType === SETTINGS.USERS.MEMBER" class="mt-5 sm:mt-0">
            <button tuiButton (click)="paymentPageNavigate()">
              <div class="flex justify-center items-center w-[180px] sm:w-[160px] ">
               <p class="flex justify-center items-center text-[13px] h-[24px]">Add Payment</p>
              </div>
            </button>
          </div>
        </div> -->
      </div>
    </div>
  </section>

  <section id="payments" *ngIf="tabIndex === 1">
    <div class="mt-5 sm:mt-10">
      <div class="w-full sm:w-3/4 md:3/4 lg:w-3/4 mx-auto">
        <div class="relative">
          <div class="container w-[265px] min-w-full">
            <div
              class="w-full flex flex-col sm:flex-row sm:justify-between border-b border-[#bb0021] py-2"
            >
              <div class="flex items-center gap-3 w-full"></div>
              <div class="flex gap-2 mt-3 sm:mt-0">
                <div>
                  <button
                    tuiButton
                    appearance="outline"
                    (click)="toggle()"
                    class="w-[80px] sm:w-[200px] hover:outline-[#bb0021] hover:text-[#bb0021] flex gap-3 items-center"
                  >
                    <tui-svg
                      src="tuiIconSlidersLarge"
                      class="sm:pt-3 rotate-90 flex items-center"
                    ></tui-svg>
                    <span class="hidden sm:block">Advanced Search</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="mt-2 sm:mt-0">
              <div
                class="flex flex-col lg:flex-row justify-between"
                *ngIf="showSearch"
              >
                <div class="flex sm:items-center gap-1 flex-col sm:flex-row">
                  <div class="w-full sm:w-40">
                    <tui-input
                      tuiTextfieldIconLeft="tuiIconSearchLarge"
                      [tuiTextfieldCleaner]="true"
                      tuiTextfieldSize="m"
                      [tuiTextfieldLabelOutside]="true"
                      [style.text-align]="'left'"
                      class=""
                      [(ngModel)]="searchText"
                      (tuiValueChanges)="cancelSearch($event)"
                    >
                      Search
                      <input autocomplete="fname" tuiTextfield type="text" />
                    </tui-input>
                  </div>
                  <div class="bg-[#6A6A6A] h-10 w-[1px] hidden sm:block"></div>
                  <div class="w-full sm:w-40 py-3">
                    <tui-select
                      [(ngModel)]="dateTypeSelect"
                      tuiTextfieldSize="m"
                      [tuiTextfieldLabelOutside]="true"
                      [style.text-align]="'left'"
                      class=""
                    >
                      Date Search
                      <input tuiTextfield type="text" />
                      <tui-data-list-wrapper *tuiDataList [items]="dateType">
                      </tui-data-list-wrapper>
                    </tui-select>
                  </div>
                  <div
                    class="bg-[#6A6A6A] h-10 w-[1px] hidden sm:block"
                    *ngIf="dateTypeSelect !== null"
                  ></div>
                  <div
                    class="w-full sm:w-[220px] py-3"
                    *ngIf="dateTypeSelect !== null"
                  >
                    <tui-input-date-range
                      class="b-form"
                      tuiTextfieldSize="m"
                      [(ngModel)]="dateFilter"
                      place
                    >
                      Choose dates
                    </tui-input-date-range>
                  </div>
                  <div class="bg-[#6A6A6A] h-10 w-[1px] hidden sm:block"></div>
                  <div class="w-full sm:w-[100px] my-3">
                    <button
                      tuiButton
                      tuiTextfieldSize="s"
                      type="button"
                      class="w-full"
                      (click)="search()"
                    >
                      <tui-svg
                        src="tuiIconSearchLarge"
                        class="pr-2 text-white"
                      ></tui-svg>
                      <span class="text-white">Search</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="flex justify-between p-2 pr-5 bg-[#faf0f2] rounded mt-2 w-full"
              *ngIf="statusMsg"
            >
              <div class="flex items-center">
                <img src="/assets/img/resulticon.png" alt="" />
                <p class="text-black pl-2">{{ showText() }}</p>
                <!--        <p class="text-[#D8D8D8] pl-2" >Showing Results for “Active” members</p>-->
              </div>
              <div>
                <button class="text-[#bb0021]" (click)="resetStatus()">
                  Reset
                </button>
              </div>
            </div>
            <tui-loader [overlay]="true" [showLoader]="isLoading">
              <div class="overflow-x-scroll" style="white-space: nowrap">
                <table class="tui-table w-full">
                  <thead tuiThead class="">
                    <tr class="tui-table__tr">
                      <th class="tui-table__th">Payment ID</th>
                      <!-- <th class="tui-table__th">Member Name</th>
                      <th class="tui-table__th">Member ID</th> -->
                      <!-- <th colspan="2" class="tui-table__th">
                        <div class="flex flex-col mt-5">
                          <div class="">Validity Period</div>
                          <div class="flex flex-row justify-between">
                            <div class="">From</div>
                            <div class="">To</div>
                          </div>
                        </div>
                      </th> -->
                      <th class="tui-table__th">
                        <div class="flex">
                          <span>Validity Period From</span>
                          <tui-svg
                            class="nav-icon group-hover:text-accent ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                            src="tuiIconChevronUp"
                            (click)="toggleSortValidFromDate()"
                            *ngIf="validFromSort === -1"
                          ></tui-svg>

                          <tui-svg
                            class="nav-icon group-hover:text-accent ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                            src="tuiIconChevronDown"
                            (click)="toggleSortValidFromDate()"
                            *ngIf="validFromSort === 1"
                          ></tui-svg>
                        </div>
                      </th>
                      <th class="tui-table__th">
                        <div class="flex">
                          <span>Validity Period To</span>
                          <tui-svg
                            class="nav-icon group-hover:text-accent ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                            src="tuiIconChevronUp"
                            (click)="toggleSortValidToDate()"
                            *ngIf="validToSort === -1"
                          ></tui-svg>

                          <tui-svg
                            class="nav-icon group-hover:text-accent ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                            src="tuiIconChevronDown"
                            (click)="toggleSortValidToDate()"
                            *ngIf="validToSort === 1"
                          ></tui-svg>
                        </div>
                      </th>
                      <th class="tui-table__th">
                        <div class="flex">
                          <span>Payment Date</span>
                          <tui-svg
                            class="nav-icon group-hover:text-accent ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                            src="tuiIconChevronUp"
                            (click)="toggleSortPaymentDate()"
                            *ngIf="paymentDateSort === -1"
                          ></tui-svg>

                          <tui-svg
                            class="nav-icon group-hover:text-accent ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                            src="tuiIconChevronDown"
                            (click)="toggleSortPaymentDate()"
                            *ngIf="paymentDateSort === 1"
                          ></tui-svg>
                        </div>
                      </th>
                      <th class="tui-table__th">Amount (LKR)</th>
                      <th class="tui-table__th">Payment Method</th>
                      <th class="tui-table__th">Status</th>
                      <th class="tui-table__th">Payment Presets</th>
                      <th class="tui-table__th">Staff Name</th>
                      <th class="tui-table__th" *ngIf="user.role !== 'USER'">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody class="">
                    <tr
                      class="tui-table__tr"
                      *ngFor="let data of paymentData; let i = index"
                    >
                      <td class="tui-table__td">
                        {{ data.paymentId ? data.paymentId : "-" }}
                      </td>
                      <!-- <td class="tui-table__td">{{ data.member?.firstname ? data.member?.firstname + ' ' + data.member?.lastname : '-' }}</td>
                      <td class="tui-table__td" style="cursor: pointer" (click)="navToSingleMember(data.member?._id)">{{ data.member?.membershipId ? data.member.membershipId : '-'}}</td> -->
                      <td class="tui-table__td">
                        {{ data.validFrom ? formatDate(data.validFrom) : "-" }}
                      </td>
                      <td class="tui-table__td">
                        {{ data.validTo ? formatDate(data.validTo) : "-" }}
                      </td>
                      <td class="tui-table__td">
                        {{ data.date ? formatDate(data.date) : "-" }}
                      </td>
                      <td class="tui-table__td">
                        {{
                          data.amount ? (data.amount | number : "1.2-2") : "-"
                        }}
                      </td>
                      <td class="tui-table__td">
                        {{ showPaymentMethod(data) }}
                      </td>
                      <td class="tui-table__td">
                        <div
                          class="flex items-center gap-1"
                          *ngIf="isPaymentPaid(data)"
                        >
                          <div
                            class="w-[10px] h-[10px] rounded-full bg-[#4AC99B]"
                          ></div>
                          Paid
                        </div>
                        <div
                          class="flex items-center gap-1"
                          *ngIf="!isPaymentPaid(data)"
                        >
                          <div
                            class="w-[10px] h-[10px] rounded-full bg-[#FF4646]"
                          ></div>
                          Not Paid
                        </div>
                      </td>
                      <td class="tui-table__td">
                        {{ data.paymentPreset ? data.paymentPreset : "-" }}
                      </td>
                      <td class="tui-table__td">
                        {{
                          data.handledBy?.firstname
                            ? data.handledBy?.firstname +
                              " " +
                              data.handledBy?.lastname
                            : "Self"
                        }}
                      </td>
                      <td class="tui-table__td" *ngIf="user.role !== 'USER'">
                        <div class="flex items-center justify-between">
                          <a
                            class="text-[#bb0021]"
                            style="cursor: pointer"
                            (click)="navigateToPaymentUpdate(data)"
                            >Edit</a
                          >
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div *ngIf="paymentData.length === 0 && !isLoading" class="mt-3">
                <p class="text-[#D8D8D8] text-center">No Data</p>
              </div>
            </tui-loader>
            <div class="text-black py-10 flex justify-end w-full max-w-full">
              <tui-pagination
                [index]="pageSize.pageIndex - 1"
                [length]="pageSize.length"
                (indexChange)="goToPage($event)"
                class="text-black"
              >
              </tui-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="health-analysis" *ngIf="tabIndex === 2">
    <tui-loader [overlay]="true" [showLoader]="isLoadingAtt" class="mt-3">
      <div class="flex justify-center mt-5 sm:mt-20">
        <div class="flex flex-col w-full sm:w-2/4 md:3/4 lg:w-2/4">
          <div class="flex flex-col sm:flex-row mt-2 w-full">
            <div class="w-full p-2 pl-10 pr-10">
              <div class="flex justify-between items-center gap-2">
                <label class="sub-headings ml-1">Notes</label>
                <svg
                  *ngIf="user.userType === SETTINGS.USERS.ADMIN"
                  (click)="onClickCancel(content)"
                  style="cursor: pointer"
                  class="mr-1"
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="15"
                  height="15"
                  viewBox="0,0,256,256"
                >
                  <g transform="">
                    <g
                      fill-opacity="0"
                      fill="#dddddd"
                      fill-rule="nonzero"
                      stroke="none"
                      stroke-width="1"
                      stroke-linecap="butt"
                      stroke-linejoin="miter"
                      stroke-miterlimit="10"
                      stroke-dasharray=""
                      stroke-dashoffset="0"
                      font-family="none"
                      font-weight="none"
                      font-size="none"
                      text-anchor="none"
                      style="mix-blend-mode: normal"
                    >
                      <path d="M0,256v-256h256v256z" id="bgRectangle"></path>
                    </g>
                    <g
                      fill="#bb0021"
                      fill-rule="nonzero"
                      stroke="none"
                      stroke-width="1"
                      stroke-linecap="butt"
                      stroke-linejoin="miter"
                      stroke-miterlimit="10"
                      stroke-dasharray=""
                      stroke-dashoffset="0"
                      font-family="none"
                      font-weight="none"
                      font-size="none"
                      text-anchor="none"
                      style="mix-blend-mode: normal"
                    >
                      <g transform="scale(5.12,5.12)">
                        <path
                          d="M43.125,2c-1.24609,0 -2.48828,0.48828 -3.4375,1.4375l-0.8125,0.8125l6.875,6.875c-0.00391,0.00391 0.8125,-0.8125 0.8125,-0.8125c1.90234,-1.90234 1.89844,-4.97656 0,-6.875c-0.95312,-0.94922 -2.19141,-1.4375 -3.4375,-1.4375zM37.34375,6.03125c-0.22656,0.03125 -0.4375,0.14453 -0.59375,0.3125l-32.4375,32.46875c-0.12891,0.11719 -0.22656,0.26953 -0.28125,0.4375l-2,7.5c-0.08984,0.34375 0.01172,0.70703 0.26172,0.95703c0.25,0.25 0.61328,0.35156 0.95703,0.26172l7.5,-2c0.16797,-0.05469 0.32031,-0.15234 0.4375,-0.28125l32.46875,-32.4375c0.39844,-0.38672 0.40234,-1.02344 0.01563,-1.42187c-0.38672,-0.39844 -1.02344,-0.40234 -1.42187,-0.01562l-32.28125,32.28125l-4.0625,-4.0625l32.28125,-32.28125c0.30078,-0.28906 0.39063,-0.73828 0.22266,-1.12109c-0.16797,-0.38281 -0.55469,-0.62109 -0.97266,-0.59766c-0.03125,0 -0.0625,0 -0.09375,0z"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <tui-textarea
                [(ngModel)]="notes"
                class="tui-space_bottom-4 field-small mt-2 note-section"
                disabled="true"
              >
              </tui-textarea>
            </div>
          </div>

          <ng-template #content let-context>
            <tui-textarea
              [(ngModel)]="tempNotes"
              class="tui-space_bottom-4 field-medium mt-2"
            >
            </tui-textarea>
            <div class="flex gap-3" style="justify-content: center">
              <button
                tuiButton
                (click)="context.complete()"
                class="modal-button"
                appearance="flat"
              >
                Cancel
              </button>
              <button
                tuiButton
                (click)="saveNote(); context.complete()"
                class="modal-button"
              >
                Save
              </button>
            </div>
          </ng-template>

          <div class="flex flex-col sm:flex-row mt-2 w-full">
            <div class="w-full p-2 pl-10 pr-10">
              <div class="flex justify-between items-center gap-2">
                <label class="sub-headings ml-1">Attachments</label>
                <div
                  *ngIf="user.userType === SETTINGS.USERS.ADMIN"
                  class="svg-container"
                  (click)="triggerFileInput()"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    width="25"
                    height="25"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="#bb0021"
                        stroke-width="1.5"
                      ></circle>
                      <path
                        d="M15 12L12 12M12 12L9 12M12 12L12 9M12 12L12 15"
                        stroke="#bb0021"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      ></path>
                    </g>
                  </svg>
                </div>
                <input
                  type="file"
                  id="fileInput"
                  (change)="onFileSelected($event)"
                  accept=".pdf,.docx,.jpg,.png"
                  style="display: none"
                />
              </div>
              <div
                *ngFor="let file of memberFiles; let i = index"
                class="flex justify-between items-center mx-3 gap-5 mt-5"
              >
                <a
                  style="color: #bb0021"
                  target="_blank"
                  href="{{ file.url }}"
                  >{{ file.name }}</a
                >
                <span
                  style="cursor: pointer"
                  (click)="openDeleteConfirmation(i, file.name)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="15"
                    height="15"
                    viewBox="0,0,256,256"
                  >
                    <g transform="">
                      <g
                        fill-opacity="0"
                        fill="#dddddd"
                        fill-rule="nonzero"
                        stroke="none"
                        stroke-width="1"
                        stroke-linecap="butt"
                        stroke-linejoin="miter"
                        stroke-miterlimit="10"
                        stroke-dasharray=""
                        stroke-dashoffset="0"
                        font-family="none"
                        font-weight="none"
                        font-size="none"
                        text-anchor="none"
                        style="mix-blend-mode: normal"
                      >
                        <path d="M0,256v-256h256v256z" id="bgRectangle"></path>
                      </g>
                      <g
                        fill="#bb0021"
                        fill-rule="nonzero"
                        stroke="none"
                        stroke-width="1"
                        stroke-linecap="butt"
                        stroke-linejoin="miter"
                        stroke-miterlimit="10"
                        stroke-dasharray=""
                        stroke-dashoffset="0"
                        font-family="none"
                        font-weight="none"
                        font-size="none"
                        text-anchor="none"
                        style="mix-blend-mode: normal"
                      >
                        <g transform="scale(5.12,5.12)">
                          <path
                            d="M7.71875,6.28125l-1.4375,1.4375l17.28125,17.28125l-17.28125,17.28125l1.4375,1.4375l17.28125,-17.28125l17.28125,17.28125l1.4375,-1.4375l-17.28125,-17.28125l17.28125,-17.28125l-1.4375,-1.4375l-17.28125,17.28125z"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </tui-loader>
  </section>

  <section
    id="Change Password"
    *ngIf="tabIndex === 3 && user.userType === SETTINGS.USERS.MEMBER"
  >
    <tui-loader [overlay]="true" [showLoader]="isLoadingAtt" class="mt-3">
      <div class="flex justify-center mt-5 sm:mt-20">
        <div class="flex flex-col w-full sm:w-[400px]">
          <div>
            <form [formGroup]="passwordForm" class="w-full">
              <div class="w-full">
                <label for="password" class="text-[#FFFFFFB8] w-full"
                  >Old Password</label
                >
                <tui-input-password
                  formControlName="oldPassword"
                  tuiTextfieldSize="l"
                  [tuiTextfieldCleaner]="true"
                  [tuiTextfieldLabelOutside]="true"
                  [style.text-align]="'left'"
                  class="tui-space_top-1"
                >
                  Password
                  <input autocomplete="fname" tuiTextfield type="text" />
                </tui-input-password>
              </div>
              <div class="mt-4">
                <label for="password" class="text-[#FFFFFFB8] w-full"
                  >New Password
                </label>
                <tui-input-password
                  formControlName="newPassword"
                  tuiTextfieldSize="l"
                  [tuiTextfieldCleaner]="true"
                  [tuiTextfieldLabelOutside]="true"
                  [style.text-align]="'left'"
                  class="tui-space_top-1"
                >
                  Password
                  <input autocomplete="fname" tuiTextfield type="text" />
                </tui-input-password>
              </div>
              <div class="mt-4">
                <label for="passwordConfirm" class="text-[#FFFFFFB8]"
                  >Confirm Password</label
                >
                <tui-input-password
                  formControlName="confirmPassword"
                  tuiTextfieldSize="l"
                  [tuiTextfieldCleaner]="true"
                  [tuiTextfieldLabelOutside]="true"
                  [style.text-align]="'left'"
                  class="tui-space_top-1"
                >
                  Re-Password
                  <input autocomplete="lname" tuiTextfield type="text" />
                </tui-input-password>
              </div>
              <div class="flex gap-3 mt-5">
                <div class="w-full">
                  <button
                    (click)="cancel()"
                    appearance="secondary"
                    tuiButton
                    type="button"
                    class="w-full"
                  >
                    Cancel
                  </button>
                </div>
                <div class="w-full">
                  <button
                    [disabled]="passwordForm.invalid"
                    (click)="onChangePassword()"
                    tuiButton
                    type="button"
                    class="w-full"
                  >
                    Update
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </tui-loader>
  </section>
</div>
